// src/components/admin/AdminHeader.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    BarChart3, Settings, Map, User, Users, AlertCircle,
    Bell, ShoppingBag, DollarSign, Package, RefreshCw
} from 'lucide-react';
import { AdminPage } from './types';
import './AdminHeader.css';

interface AdminHeaderProps {
    activePage: AdminPage;
    onPageChange: (page: AdminPage) => void;
    errorCount?: number;
}

const navItems: { id: AdminPage; icon: React.ElementType; label: string }[] = [
    { id: 'stats', icon: BarChart3, label: 'Estatísticas' },
    { id: 'platform-management', icon: Settings, label: 'Gerenciamento da Plataforma' },
    { id: 'content-map', icon: Map, label: 'Mapa de Conteúdo' },
    { id: 'users', icon: User, label: 'Usuários' },
    { id: 'groups', icon: Users, label: 'Grupos de Estudo' },
    { id: 'errors', icon: AlertCircle, label: 'Erros' },
    { id: 'notifications', icon: Bell, label: 'Notificações' },
    { id: 'marketplace', icon: ShoppingBag, label: 'Cupons' },
    { id: 'sales', icon: DollarSign, label: 'Vendas' },
    { id: 'products-admin', icon: Package, label: 'Produtos' },
    { id: 'subscriptions', icon: RefreshCw, label: 'Assinaturas' },
];

const AdminHeader: React.FC<AdminHeaderProps> = ({ activePage, onPageChange, errorCount = 0 }) => {
    const navigate = useNavigate();

    return (
        <header className="admin-header">
            <div className="admin-header-left">
                <button
                    className="admin-header-wordmark"
                    onClick={() => navigate('/dashboard')}
                    aria-label="Voltar ao dashboard"
                >
                    <img
                        src="/graia-logo-azul.png"
                        alt=""
                        className="admin-header-logo-img"
                    />
                    <span className="admin-header-wordmark-text">GRAIA</span>
                </button>
            </div>
            <nav className="admin-header-nav">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activePage === item.id;
                    const showBadge = item.id === 'errors' && errorCount > 0;
                    return (
                        <button
                            key={item.id}
                            className={`admin-nav-btn${isActive ? ' active' : ''}`}
                            onClick={() => onPageChange(item.id)}
                            title={item.label}
                        >
                            <span className="admin-nav-btn-icon">
                                <Icon size={20} strokeWidth={1.5} />
                                {showBadge && (
                                    <span className="admin-nav-badge">{errorCount}</span>
                                )}
                            </span>
                            <span className="admin-nav-btn-label">{item.label}</span>
                        </button>
                    );
                })}
            </nav>
        </header>
    );
};

export default AdminHeader;
